import { Item } from '../../../common/models/item.model';
import { generateRandomId } from '../generateRandomId';
import type { PriceCompareItem } from '../types/PriceCompareItem';

type PriceCompareItemInput = Partial<PriceCompareItem>;

export const createPriceCompareItem = (item?: PriceCompareItemInput): PriceCompareItem => {
    const priceCompareItem = new Item(item) as PriceCompareItem;
    priceCompareItem.id = item?.id ?? generateRandomId();
    return priceCompareItem;
};
